import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import './AdminPanel.scss';
import SelectedSong from '../../Components/SelectedSong/SelectedSong';
import FuntoneButton from '../../Components/FuntoneButton/FuntoneButton';
import SelectList from 'app/Components/Shared/SelectList/SelectList';
import SongCard from '../../Components/SongCard/SongCard';
import ActionCard from '../../Components/ActionCard/ActionCard';
import SubscriberSwiper from '../../Components/SubscriberSwiper/SubscriberSwiper';
import {
  FuntoneSubscriptionStatus,
  setIsChangePackageFlow,
  getGallery,
  setIsGalleryMode,
  setIsEditPlaylistFlow,
  setIsChangeDefaultSongFlow,
  setIsAddServiceFlow,
  setIsAssignToContactFlow,
  showToast,
  setDefaultSong,
  setShuffle,
  setSelectedSubscriber,
  setSelectedSong as setGlobalSelectedSong,
  saveToHistory,
} from '../../FuntoneSlice';
import MusicIconCLC from './Images/music-icon-clc.png';
import MusicIconGolan from './Images/music-icon-gln.png';
import { useScreenNavigation } from '../../Utils/ScreenNavigationUtils';
import MyPlaylistButton from '../../Components/MyPlaylistButton/MyPlaylistButton';
import Config from 'app/Config';
import { isMobile } from 'react-device-detect';
import {
  dwhFuntoneEnterManagementPage,
  dwhFuntoneChangeDefaultSong,
  dwhFuntoneChangeDefaultSongSuccess,
  dwhFuntoneChangeDefaultSongFailed,
  dwhFuntoneChangePlaybackConcept,
  dwhFuntoneChangePlaybackConceptSuccess,
  dwhFuntoneChangePlaybackConceptFailed,
} from '../../Reports/dwhReports';
import { getCommonReportParams } from '../../Reports/reportHelpers';
import { getMarketCode } from 'app/utilities/domain/domainConstants';

const AdminPanel = (props) => {
  const { selectedSong, selectedPackage, subscribersData, selectedSubscriber } = props.funtoneSlice;
  const { myPlaylistButtonImage, packages, randomPlaylistImage, downloadMoreSongsTitle, songSelectionSectionTitle } = props.contentData;
  const [selectedSongOption, setSelectedSongOption] = useState(null);
  const [currentPackage, setCurrentPackage] = useState(null);

  const selectedSongTitle = selectedPackage ? 'השיר שבחרת' : 'השיר שלך';

  const selfcarePage = useSelector((state) => state.selfcarePage);
  const funtoneSlice = useSelector((state) => state.FuntoneSlice);
  const authContact = useSelector((state) => state.authentication?.loginData?.userDetails?.contactNumber);
  const loginData = useSelector((state) => state.authentication?.loginData);
  const dispatch = useDispatch();
  const { navigateToCatalog, navigateToPackageSelect, navigateToSongs, navigateToConfigureSongs } = useScreenNavigation();

  // Clear change package flow flag when entering AdminPanel
  useEffect(() => {
    if (funtoneSlice.isChangePackageFlow) {
      dispatch(setIsChangePackageFlow(false));
    }
  }, [dispatch, funtoneSlice.isChangePackageFlow]);

  // Report entering management page
  useEffect(() => {
    if (selectedSubscriber && loginData) {
      const reportParams = getCommonReportParams(selectedSubscriber, loginData);
      const isExistingSubscriber = selectedSubscriber?.hasService ? 'מנוי קיים' : 'לא מנוי המתנה נעימה';
      dwhFuntoneEnterManagementPage({
        ...reportParams,
        ban: loginData?.userDetails?.ban || '',
        crmId: loginData?.userDetails?.crmId || '',
        isExistingSubscriber,
      });
    }
  }, [loginData]);

  useEffect(() => {
    if (selfcarePage?.subscribersByProduct?.Cellular?.length && subscribersData) {
      const loggedInSubscriber = subscribersData.find((s) => s.cli === authContact);

      // If no subscriber is selected, or if the selected subscriber doesn't have service
      if (!selectedSubscriber || (selectedSubscriber && !selectedSubscriber.hasService)) {
        // If logged-in user has service, select them
        if (loggedInSubscriber && loggedInSubscriber.hasService) {
          dispatch(setSelectedSubscriber(loggedInSubscriber));
        } else {
          // Otherwise, select the first subscriber that has service
          const subscriberWithService = subscribersData.find((s) => s.hasService);
          if (subscriberWithService) {
            dispatch(setSelectedSubscriber(subscriberWithService));
          } else {
            // No subscriber has service, navigate to catalog
            navigateToCatalog();
          }
        }
      }
    }
  }, [selfcarePage, authContact, selectedSubscriber, subscribersData, dispatch, navigateToCatalog]);

  // Sync selectedSubscriber with fresh data from subscribersData when it updates
  useEffect(() => {
    if (selectedSubscriber && subscribersData && subscribersData.length > 0) {
      const cli = typeof selectedSubscriber === 'string' ? selectedSubscriber : selectedSubscriber?.cli;
      if (cli) {
        const freshSubscriber = subscribersData.find((s) => s.cli === cli);
        // Only update if we found fresh data and it's different from current
        if (freshSubscriber && JSON.stringify(freshSubscriber) !== JSON.stringify(selectedSubscriber)) {
          dispatch(setSelectedSubscriber(freshSubscriber));
        }
      }
    }
  }, [subscribersData]); // Only watch subscribersData changes

  // Update current package when selected subscriber changes
  useEffect(() => {
    if (selectedSubscriber?.packageCode && packages?.expandedValue) {
      const foundPackage = packages.expandedValue.find(
          (pkg) => pkg.code?.value?.toUpperCase().trim() === selectedSubscriber.packageCode.toUpperCase().trim(),
      );
      setCurrentPackage(foundPackage || null);
    } else {
      setCurrentPackage(null);
    }
  }, [selectedSubscriber, packages]);

  // Set the correct selected option when subscriber changes
  useEffect(() => {
    if (selectedSubscriber) {
      // Check if shuffle mode is enabled
      if (selectedSubscriber.isShuffleMode) {
        setSelectedSongOption('random-song');
      } else {
        // Default to default-song
        setSelectedSongOption('default-song');
      }
    }
  }, [selectedSubscriber]);

  const options = [
    {
      key: 'Track 1',
      value: 'default-song',
      song: {
        id: 2500038,
        description: selectedSubscriber?.defaultSongTitle,
        image: selectedSubscriber?.defaultSongImage,
        author: selectedSubscriber?.defaultSongArtistName,
      },
    },
    {
      key: 'Track 2',
      value: 'random-song',
      song: {
        id: 2500012,
        image: Config.epiBaseUrl + randomPlaylistImage.value.url,
      },
    },
  ];

  const onSelect = async (optionValue) => {
    // Get the current subscriber CLI
    const cli = typeof selectedSubscriber === 'string' ? selectedSubscriber : selectedSubscriber?.cli;

    if (!cli) {
      dispatch(showToast('שגיאה: לא נבחר מנוי'));
      return;
    }

    // Find the full option object from the options array
    const selectedOption = options.find((opt) => opt.value === optionValue);

    // Handle selection based on option value
    if (optionValue === 'default-song') {
      // Check if default song is already selected
      if (selectedSongOption === 'default-song' && !selectedSubscriber?.isShuffleMode) {
        // Already set as default song, do nothing
        return;
      }

      // Check if this is a playback concept change (switching from random to default)
      const isPlaybackConceptChange = selectedSubscriber?.isShuffleMode;

      // Set the default song - use the subscriber's current default song product ID
      const productId = selectedSubscriber?.defaultSongId;
      if (productId) {
        const reportParams = getCommonReportParams(selectedSubscriber, loginData);

        // Report change playback concept if switching from shuffle
        if (isPlaybackConceptChange) {
          dwhFuntoneChangePlaybackConcept({
            ...reportParams,
            ban: loginData?.userDetails?.ban || '',
            crmId: loginData?.userDetails?.crmId || '',
          });
        } else {
          // Report change default song initiated
          dwhFuntoneChangeDefaultSong({
            ...reportParams,
            ban: loginData?.userDetails?.ban || '',
            crmId: loginData?.userDetails?.crmId || '',
          });
        }

        const action = await dispatch(
          setDefaultSong({
            subscriber: cli,
            productId: productId,
          }),
        );

        if (action.type.endsWith('/fulfilled')) {
          if (isPlaybackConceptChange) {
            // Report change playback concept success
            dwhFuntoneChangePlaybackConceptSuccess({
              ...reportParams,
              ban: loginData?.userDetails?.ban || '',
              crmId: loginData?.userDetails?.crmId || '',
            });
          } else {
            // Report change default song success
            dwhFuntoneChangeDefaultSongSuccess({
              ...reportParams,
              ban: loginData?.userDetails?.ban || '',
              crmId: loginData?.userDetails?.crmId || '',
            });
          }
          setSelectedSongOption(optionValue);
          // Refresh gallery to get updated state
          await dispatch(getGallery());
        } else {
          if (isPlaybackConceptChange) {
            // Report change playback concept failure
            dwhFuntoneChangePlaybackConceptFailed({
              ...reportParams,
              ban: loginData?.userDetails?.ban || '',
              crmId: loginData?.userDetails?.crmId || '',
            });
          } else {
            // Report change default song failure
            dwhFuntoneChangeDefaultSongFailed({
              ...reportParams,
              ban: loginData?.userDetails?.ban || '',
              crmId: loginData?.userDetails?.crmId || '',
            });
          }
        }
      }
    } else if (optionValue === 'random-song') {
      // Check if shuffle mode is already enabled
      if (selectedSongOption === 'random-song' && selectedSubscriber?.isShuffleMode) {
        // Already in shuffle mode, do nothing
        return;
      }

      // This is always a playback concept change (switching from default to random)
      const reportParams = getCommonReportParams(selectedSubscriber, loginData);

      // Report change playback concept initiated
      dwhFuntoneChangePlaybackConcept({
        ...reportParams,
        ban: loginData?.userDetails?.ban || '',
        crmId: loginData?.userDetails?.crmId || '',
      });

      // Set shuffle mode
      const action = await dispatch(
        setShuffle({
          subscriber: cli,
          profileId: null,
          isSetShuffle: true,
        }),
      );

      if (action.type.endsWith('/fulfilled')) {
        // Report change playback concept success
        dwhFuntoneChangePlaybackConceptSuccess({
          ...reportParams,
          ban: loginData?.userDetails?.ban || '',
          crmId: loginData?.userDetails?.crmId || '',
        });
        setSelectedSongOption(optionValue);
        await dispatch(getGallery());
      } else {
        // Report change playback concept failure
        dwhFuntoneChangePlaybackConceptFailed({
          ...reportParams,
          ban: loginData?.userDetails?.ban || '',
          crmId: loginData?.userDetails?.crmId || '',
        });
      }
    }
  };

  const handleSubscriberSelect = (subscriber) => {
    if (!subscriber?.hasService) {
      return;
    }
    dispatch(setSelectedSubscriber(subscriber));
    console.log('Selected subscriber:', subscriber);
  };

  const handleAddService = (subscriber) => {
    // subscriber is the full subscriber object passed from SubscriberCard
    if (subscriber) {
      // Update global selected subscriber
      dispatch(setSelectedSubscriber(subscriber));

      // Clear any selected song since this is just adding a service
      dispatch(setGlobalSelectedSong(null));

      // Set the change package flow flow flag
      dispatch(setIsChangePackageFlow(true));

      //set to add service flow
      dispatch(setIsAddServiceFlow(true));
      // Navigate to package select
      navigateToPackageSelect();
    } else {
      dispatch(showToast('שגיאה: לא נמצא מנוי'));
    }
  };

  const handleChangePackage = () => {
    dispatch(setIsChangePackageFlow(true));
    navigateToPackageSelect();
  };

  const handleChangeSong = async () => {
    // New behavior: Change default song flow
    const cli = typeof selectedSubscriber === 'string' ? selectedSubscriber : selectedSubscriber?.cli;

    if (!cli) {
      dispatch(showToast('שגיאה: לא נבחר מנוי'));
      return;
    }

    dispatch(setIsChangeDefaultSongFlow(true));
    const galleryAction = await dispatch(getGallery());

    if (galleryAction.type.endsWith('/fulfilled')) {
      navigateToSongs();
    } else {
      dispatch(showToast('שגיאה בטעינת ההורדות'));
    }
  };

  const handleViewMyDownloads = async () => {
    // Original gallery mode behavior
    dispatch(setIsGalleryMode(true));
    await dispatch(getGallery());
    navigateToSongs();
  };

  const handleEditPlaylist = async () => {
    // Fetch playlist for current subscriber and navigate to SongsPage in playlist edit mode
    dispatch(setIsEditPlaylistFlow(true));
    const playlistAction = await dispatch(getGallery());

    if (playlistAction.type.endsWith('/fulfilled')) {
      navigateToSongs();
    } else {
      // Handle error - show toast
      dispatch(showToast('יש להוריד שיר לפני עריכת הפלייליסט'));
    }
  };

  const handleConfigureSongs = async () => {
    // Load gallery and navigate to configure songs screen
    const galleryAction = await dispatch(getGallery());

    if (galleryAction.type.endsWith('/fulfilled')) {
      // Check if there are any configured songs (songs with profiles/contacts)
      const gallery = galleryAction.payload?.results?.subscriberGallery?.items?.item || [];
      const galleryArray = Array.isArray(gallery) ? gallery : [gallery];
      const hasSongsWithContacts = galleryArray.some(song => {
        const profiles = song.profiles?.profile;
        if (!profiles) return false;
        const profilesArray = Array.isArray(profiles) ? profiles : [profiles];
        return profilesArray.length > 0;
      });

      if (!hasSongsWithContacts) {
        // No configured songs, navigate to change default song flow
        dispatch(setIsAssignToContactFlow(true));
        navigateToSongs();
      } else {
        // Has configured songs, navigate to configure songs screen
        navigateToConfigureSongs();
      }
    } else {
      dispatch(showToast('יש להוריד שיר לפני התאמת שיר'));
    }
  };

  const menuActions = [{ key: 'change-song', label: 'החלפת שיר', onClick: handleChangeSong }];

  const playlistEditActions = [{ key: 'editPlaylist', label: 'עריכת פלייליסט', onClick: handleEditPlaylist }];

  const marketCode = getMarketCode();
  const musicIcon = marketCode === 'CLC' ? MusicIconCLC : MusicIconGolan;

  return (
    <div className={'admin-panel-page'}>
      <div className='top-content'>
        <span className='title'>ניהול המתנה נעימה</span>
        {subscribersData?.length === 1 && selectedSubscriber && (
          <div className='single-subscriber-info'>
            {selectedSubscriber.fullName.trim() !== "" && (
              <>
                <span className='subscriber-name'>{selectedSubscriber.fullName}</span>
                <span className='separator'> | </span>
              </>
            )}
            <span className='subscriber-number'>{selectedSubscriber.cli}</span>
          </div>
        )}
      </div>
      {subscribersData?.length > 1 && (
        <div className='subscriber-swiper-wrapper'>
          <div className='subscriber-swiper-container'>
            <SubscriberSwiper
              subscribers={subscribersData}
              selectedSubscriber={selectedSubscriber}
              onSubscriberSelect={handleSubscriberSelect}
              onAddService={handleAddService}
            />
          </div>
        </div>
      )}
      <div className='main-content'>
        {/* Show current package only if subscriber has a package */}
        {(currentPackage || selectedSubscriber?.packageDescription) && (
          <div className='current-package'>
            <div className='package-info'>
              <span className='package-title'>{currentPackage?.title?.value || ''}</span>
              <span className='package-description'>{currentPackage?.description?.value || selectedSubscriber?.packageDescription}</span>
            </div>
            <FuntoneButton variant='text' text='לשינוי' onClick={handleChangePackage} />
          </div>
        )}
        <div className='song-selection'>
          <span className='section-title'>{songSelectionSectionTitle.value}</span>
          <div className='selection-options'>
            <SelectList
              key={selectedSubscriber?.cli}
              options={options}
              onClick={onSelect}
              defaultValue={selectedSongOption}
              renderItem={({ option, isSelected }) => {
                const actionsForThis = option.value === 'random-song' ? playlistEditActions : menuActions;
                return (
                  <SongCard
                    headerTitle={option.value === 'default-song' ? 'שיר קבוע ' : 'ניגון רנדומלי'}
                    song={option.song}
                    isSelected={isSelected}
                    showMenu={true}
                    menuActions={actionsForThis}
                    disableHover={true}
                  />
                );
              }}
            />
          </div>
        </div>
        <div className='my-downloads'>
          <span className='title'>הפלייליסט שלי</span>
          <div className='action-cards'>
            <MyPlaylistButton image={Config.epiBaseUrl + myPlaylistButtonImage?.value?.url} onClick={handleViewMyDownloads} />
            {!isMobile && (
              <ActionCard
                title={'רוצים להוריד עוד שירים?'}
                buttonText={'לקטלוג השירים'}
                buttonVariant='primary'
                image={musicIcon}
                imageAlt='Funtone music'
                onButtonClick={navigateToCatalog}
                variant='featured'
              />
            )}
          </div>
        </div>
        <div className='action-cards'>
          {isMobile && (
            <ActionCard
              title={downloadMoreSongsTitle.value}
              buttonText={'לקטלוג השירים'}
              buttonVariant='primary'
              image={musicIcon}
              imageAlt='Funtone music'
              onButtonClick={navigateToCatalog}
              variant='featured'
            />
          )}
          <ActionCard
            title={'בחרו שיר לאדם מיוחד'}
            subtitle={'התחילו להתאים שירים בקליק'}
            buttonText={'בואו נתחיל'}
            buttonVariant='primary'
            image={musicIcon}
            imageAlt='Funtone music'
            onButtonClick={handleConfigureSongs}
            variant='featured'
          />
        </div>
      </div>
    </div>
  );
};

export default AdminPanel;
